import { Link } from 'react-router-dom';
import SearchBox from '@/components/base/SearchBox';

type HeaderBarProps = {
  onMenu: () => void;
};

export default function HeaderBar({ onMenu }: HeaderBarProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-[68px] items-center gap-3 px-4 md:px-8">
        <button
          type="button"
          aria-label="打开菜单"
          onClick={onMenu}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-lg text-foreground-700 hover:bg-background-100 lg:hidden"
        >
          <i className="ri-menu-line"></i>
        </button>

        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap font-heading text-base font-bold text-foreground-950 lg:hidden"
        >
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-compass-3-line text-base"></i>
          </span>
          蓝导航
        </Link>

        <div className="hidden max-w-xl flex-1 sm:block">
          <SearchBox />
        </div>

        <div className="ml-auto flex items-center gap-2">
          <Link
            to="/about"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
          >
            <i className="ri-customer-service-2-line"></i>
            反馈建议
          </Link>
          <Link
            to="/about"
            aria-label="关于我们"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-lg text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:hidden"
          >
            <i className="ri-information-line"></i>
          </Link>
        </div>
      </div>

      <div className="border-t border-background-200 px-4 py-3 sm:hidden">
        <SearchBox />
      </div>
    </header>
  );
}